import { templatize } from 'Utils';

const MessageHandler = {};

MessageHandler.errors = {
  'checkout-logged-out': {
    isCritical: false,
    message: templatize`Please create an account to complete your payment.`,
  },
  'common-password': {
    isCritical: false,
    message: templatize`Passwords cannot be easily guessed phrases like "password", keyboard patterns such as "qwerty", or sequences such as "1234".`,
  },
  'email-exists': {
    isCritical: false,
    message: templatize`You already have an account with the e-mail address ${0}. Please <a href='/signIn.php${1}'>sign-in</a> here.`,
  },
  'invalid-deactivate-permissions': {
    isCritical: false,
    message: templatize`You must be the owner of the document to change its state.`,
  },
  'invalid-email': {
    isCritical: false,
    message: templatize`Please enter your email in the form you@email.com.`,
  },
  'invalid-password-confirmation': {
    isCritical: false,
    message: templatize`Passwords do not match.`,
  },
  'invalid-permissions': {
    isCritical: false,
    message: templatize`You do not have permissions to view the document you tried to access because you are not the document owner. Your documents are available in your account.`,
  },
  'invalid-plan': {
    isCritical: true,
    message: templatize`There was an error with the plan you selected. Please contact us.`,
  },
  'invalid-site': {
    isCritical: true,
    message: templatize`There was an error with the site. Please contact us.`,
  },
  'invalid-user-session': {
    isCritical: false,
    message: templatize`Invalid user session`,
  },
  'session-has-owner': {
    isCritical: false,
    message: templatize`The document specified is already owned by someone else.`,
  },
  'short-password': {
    isCritical: false,
    message: templatize`Please make your password 8 characters or longer.`,
  },
  'signin-required': {
    isCritical: false,
    message: templatize`You must be signed in to view this document.`,
  },
  'template-duplication-failed': {
    isCritical: false,
    message: templatize`Your template was not duplicated.`,
  },
  'custom-template-not-public': {
    isCritical: false,
    message: templatize`This document does not exist. Check that you have the correct link or the document owner may not be collecting responses right now.`,
  },
  'invalid-custom-template-share-key': {
    isCritical: false,
    message: templatize`Oops! You no longer have access to this document. The document owner has either revoked your access or this document no longer exists.`,
  },
};

MessageHandler.normalizeMessage = (message) => {
  const messageToNormalized = {
    'custom-template-has-owner': 'session-has-owner',
    'Missing field: creator_user_id': 'signin-required',
    'Missing field: creator_user_token': 'signin-required',
    'This document is not publicly accessible.': 'custom-template-not-public',
    'This custom template is no longer active.': 'invalid-custom-template-share-key',
    'This DocumentShare does not exist.': 'invalid-custom-template-share-key',
    'document type not found': 'invalid-document-type',
  };

  if (messageToNormalized[message]) {
    return messageToNormalized[message];
  }

  return message;
};

MessageHandler.getErrorMessage = (err = '', email = '') => {
  let errorMessage = '';
  const normalizedMessage = MessageHandler.normalizeMessage(err);
  if (MessageHandler.errors[normalizedMessage]) {
    const { message } = MessageHandler.errors[normalizedMessage];
    errorMessage = message.format(email, document.location.search);
  } else {
    errorMessage = decodeURI(err);
  }

  return errorMessage;
};

MessageHandler.getErrorRedirectUrl = (error, includeRedirect = false) => {
  const errorMessage = encodeURI(MessageHandler.getErrorMessage(error));
  if (window.COOKIE.get('userid') && window.COOKIE.get('userToken')) {
    if (!errorMessage) {
      window.Raven.captureException(new Error('Redirecting to MyDocuments.php without an error message'));
    }

    return `/myDocuments.php?error=${errorMessage}`;
  }

  let redirect = `/signIn.php?error=${errorMessage}`;
  if (includeRedirect) {
    redirect = `${redirect}&redirect_url=${window.location.pathname.slice(1)}${window.location.search}`;
  }

  return redirect;
};


module.exports = MessageHandler;



// WEBPACK FOOTER //
// ./src-assets/js/message-handler.js